module.exports = __webpack_public_path__ + "img/exchange.71a91a81.png";